import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createInvestmentActions } from './actions';
import { InvestmentActions, InvestmentState } from './types';

export const useInvestmentStore = create<InvestmentState & InvestmentActions>()(
    immer((set, get, store) => ({
        investments: [],
        loading: false,
        selectedInvestment: null,
        loadingInvestment: false,
        investmentCollaborators: [],
        loadingInvestmentCollaborators: false,
        error: undefined,
        ...createInvestmentActions(set, get, store),
    })),
);
